export const formatUrl = (url) => (url?.startsWith('/') ? url : `/${url}`);
